import { combineReducers } from 'redux';
import createUser from './user-create';
import register from './register';

export default combineReducers({
  createUser,
  register
});
